/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./zrc/scripts/sections/instafeed.js":
/*!*******************************************!*\
  !*** ./zrc/scripts/sections/instafeed.js ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var swiper_js_swiper_esm__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! swiper/js/swiper.esm */ "./node_modules/swiper/js/swiper.esm.js");

class InstafeedCarousel extends window.HTMLElement {
  constructor() {
    super();
    this.container = this;
    this.$swiper = $(this.container).find('.instafeed-carousel-container');
    this.$instafeed = $(this.container).find('#insta-feed');
    this.isLoaded = false;
    swiper_js_swiper_esm__WEBPACK_IMPORTED_MODULE_0__.Swiper.use([swiper_js_swiper_esm__WEBPACK_IMPORTED_MODULE_0__.Navigation]);
    this.swiper = new swiper_js_swiper_esm__WEBPACK_IMPORTED_MODULE_0__.Swiper(this.$swiper, {
      init: false,
      longSwipesRatio: 0,
      loop: false,
      resistanceRatio: 0,
      navigation: {
        nextEl: $(this.container).find('.swiper-button-next'),
        prevEl: $(this.container).find('.swiper-button-prev')
      },
      breakpoints: {
        0: {
          slidesOffsetBefore: 17,
          slidesOffsetAfter: 17,
          slidesPerGroup: 1,
          slidesPerView: 'auto',
          spaceBetween: 9
        },
        749: {
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          slidesPerGroup: 3,
          slidesPerView: 3,
          spaceBetween: 9
        },
        1024: {
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          slidesPerGroup: 4,
          slidesPerView: 4,
          spaceBetween: 12
        },
        1440: {
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          slidesPerGroup: 4,
          slidesPerView: 4,
          spaceBetween: 16
        }
      }
    });
    this.instaFeedLoadObserver();
  }
  instaFeedLoadObserver() {
    // Select the node that will be observed for mutations
    var targetNode = document.getElementById("insta-feed");
    // Options for the observer (which mutations to observe)
    var config = {
      childList: true,
      subtree: true
    };
    // Callback function to execute when mutations are observed
    var callback = (mutationList, observer) => {
      for (var mutation of mutationList) {
        if (mutation.type === "childList" || mutation.type === "subtree") {
          // console.log("Instafeed widget loaded.");
          this.instaFeedSlidesObserver();
          observer.disconnect();
        }
      }
    };
    // Create an observer instance linked to the callback function
    var observer = new MutationObserver(callback);
    // Start observing the target node for configured mutations
    if (targetNode) {
      observer.observe(targetNode, config);
    }
  }
  instaFeedSlidesObserver() {
    // Select the node that will be observed for mutations
    var targetNode = document.querySelector("#insta-feed .instafeed-new-layout-item:first-child img");
    // Options for the observer (which mutations to observe)
    var config = {
      attributes: true
    };
    // Callback function to execute when mutations are observed
    var callback = (mutationList, observer) => {
      for (var mutation of mutationList) {
        if (mutation.type === "attributes") {
          // console.log("Instafeed Lazy loaded image loaded");
          this.init();
          this.isLoaded = true;
          observer.disconnect();
        }
      }
    };
    // Create an observer instance linked to the callback function
    var observer = new MutationObserver(callback);
    // Start observing the target node for configured mutations
    if (targetNode) {
      observer.observe(targetNode, config);
    }
  }
  getSlides() {
    var items = $('#insta-feed a');
    var slides = [];
    items.each((index, element) => {
      var $this = $(element);
      var data = {
        anchor: $this.attr('href'),
        image: $this.find('> img').attr('data-src') ? $this.find('> img').attr('data-src') : $this.find('> img').attr('src')
      };
      var slide = this.slideTemplate(data);
      slides.push(slide);
    });
    this.swiper.appendSlide(slides);
    this.swiper.init();
  }
  slideTemplate(data) {
    var {
      image,
      anchor
    } = data;
    var template = "\n      <a class=\"instafeed-image-link swiper-slide\" href=\"".concat(anchor, "\" target=\"_blank\">\n        <img class=\"instafeed-image lazyload\" data-src=\"").concat(image, "\">\n      </a>\n    ");
    return template;
  }
  init() {
    if ($('#insta-feed a').length) {
      this.getSlides();
    } else {
      window.setTimeout(() => {
        this.init();
      }, 500);
    }
  }
}
if (window.customElements.get('instafeed-carousel') == null) {
  window.customElements.define('instafeed-carousel', InstafeedCarousel);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/******/ 	// the startup function
/******/ 	// It's empty as some runtime module handles the default behavior
/******/ 	__webpack_require__.x = x => {};
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// Promise = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"instafeed": 0
/******/ 		};
/******/ 		
/******/ 		var deferredModules = [
/******/ 			["./zrc/scripts/sections/instafeed.js","commons"]
/******/ 		];
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		var checkDeferredModules = x => {};
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime, executeModules] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0, resolves = [];
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					resolves.push(installedChunks[chunkId][0]);
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			while(resolves.length) {
/******/ 				resolves.shift()();
/******/ 			}
/******/ 		
/******/ 			// add entry modules from loaded chunk to deferred list
/******/ 			if(executeModules) deferredModules.push.apply(deferredModules, executeModules);
/******/ 		
/******/ 			// run deferred modules when all chunks ready
/******/ 			return checkDeferredModules();
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkgetmore_workflow"] = self["webpackChunkgetmore_workflow"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 		
/******/ 		function checkDeferredModulesImpl() {
/******/ 			var result;
/******/ 			for(var i = 0; i < deferredModules.length; i++) {
/******/ 				var deferredModule = deferredModules[i];
/******/ 				var fulfilled = true;
/******/ 				for(var j = 1; j < deferredModule.length; j++) {
/******/ 					var depId = deferredModule[j];
/******/ 					if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferredModules.splice(i--, 1);
/******/ 					result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 				}
/******/ 			}
/******/ 			if(deferredModules.length === 0) {
/******/ 				__webpack_require__.x();
/******/ 				__webpack_require__.x = x => {};
/******/ 			}
/******/ 			return result;
/******/ 		}
/******/ 		var startup = __webpack_require__.x;
/******/ 		__webpack_require__.x = () => {
/******/ 			// reset startup function so it can be called again when more startup code is added
/******/ 			__webpack_require__.x = startup || (x => {});
/******/ 			return (checkDeferredModules = checkDeferredModulesImpl)();
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	// run startup
/******/ 	__webpack_require__.x();
/******/ })()
;